<template>
  <div class="test" style="width: 200px; height: 200px; background: yellow">
    testtttttt
    <!-- <el-button>确定按钮</el-button>> -->
  </div>
</template>
<script>
import Vue from 'vue'
import Button from 'element-ui'
Vue.use(Button)
export default {
  name: "Test",
};
</script>
